import type { GameEvent, GameState, InstabilityState, RunPhase } from './types';

export const INSTABILITY_THRESHOLDS = [35, 65, 85, 100] as const;

export interface InstabilityUpdate {
  readonly instability: InstabilityState;
  readonly phase: RunPhase;
  readonly events: readonly GameEvent[];
}

export function addInstability(state: GameState, amount: number): InstabilityUpdate {
  if (amount <= 0 || state.phase === 'ended') {
    return { instability: state.instability, phase: state.phase, events: [] };
  }
  const nextValue = Math.min(100, state.instability.value + amount);
  const newlyTriggered = INSTABILITY_THRESHOLDS.filter(
    (threshold) => nextValue >= threshold && !state.instability.triggered.includes(threshold),
  );
  const enteredEmergency = newlyTriggered.includes(100);
  return {
    instability: {
      value: nextValue,
      triggered: [...state.instability.triggered, ...newlyTriggered],
      emergencyRemainingSeconds: enteredEmergency
        ? 20
        : state.instability.emergencyRemainingSeconds,
    },
    phase: enteredEmergency ? 'emergency' : state.phase,
    events: newlyTriggered.map((threshold) => ({
      type: 'INSTABILITY_THRESHOLD' as const,
      threshold,
    })),
  };
}
